import { Component, input, output, signal, ViewEncapsulation } from '@angular/core';
import { NgClass } from '@angular/common';
import { BackButtonBoxComponent } from '@app/framework/back-button-box/back-button-box.component';

@Component({
  selector: 'app-sidebar-header',
  imports: [NgClass, BackButtonBoxComponent],
  templateUrl: './sidebar-header.component.html',
  styleUrl: './sidebar-header.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class SidebarHeaderComponent {
  showBackButton = input(false);
  backButtonClicked = output();

  backButtonHovered = signal(false);

  protected smallTitleClicked() {
    this.backButtonClicked.emit();
  }
}
